import React from "react";
import { useLocation } from "react-router-dom";
/** Mismo asset que StartGame — sustituir por vídeo de contexto esc. 4 si procede. */
import contextVideoMp4 from "../../assets/avatares/alianzas-inversion.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "../StartGame.css";
import "./Scenario4.css";

export default function Scenario4Context3() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});

	return (
		<>
			<div className="start-game-page start-game-page--welcome sc4-context3-startgame">
				<div className="start-game-inner">
					<div className="start-game-grid">
						<div className="start-game-visual">
							<span className="start-game-badge">
								<span className="start-game-badge-dot" aria-hidden />
								Escenario 3 · Coca-Cola
							</span>
							<div className="start-game-avatar-wrap">
								<div className="start-game-avatar-inner">
									<video
										ref={videoRef}
										autoPlay
										muted={!canPlayWithSound}
										playsInline
										preload="auto"
										aria-label="Presentación visual"
									>
										<source src={contextVideoMp4} type="video/mp4" />
									</video>
								</div>
							</div>
						</div>
						<div className="start-game-panel">
							<h1 className="start-game-title">
								Alianzas{" "}
								<span className="start-game-title-accent">de inversión</span>
							</h1>
							<p className="start-game-lead">
								Lo que nunca debemos olvidar es que no hemos llegado hasta aquí solos. Lo hemos hecho caminando junto a quienes compartían una ambición común: crear valor, crecer con responsabilidad y construir proyectos capaces de trascender generaciones.
							</p>
							<p className="start-game-lead start-game-lead-tight">
								Gracias a nuestras alianzas, nos hemos hecho más fuertes. Gracias a nuestros acuerdos, hemos ampliado nuestro horizonte.
							</p>
							<p className="start-game-lead start-game-lead-tight">
								Somos una gran familia.
							</p>
							<p className="start-game-lead start-game-lead-tight">
								Y nuestros socios forman parte de la historia que hoy nos permite mirar hacia el futuro.
							</p>
							<div className="start-game-footer">
								<Scenario2NextCta
									navigateTo={ROUTES.SCENARIO4_FIN}
									activeScenario={activeScenario}
									label="Continuar"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</>
	);
}
